import { render } from "./AttrSchemeGraph.vue?vue&type=template&id=73af2531"
import script from "./AttrSchemeGraph.vue?vue&type=script&lang=js"
export * from "./AttrSchemeGraph.vue?vue&type=script&lang=js"

import "./AttrSchemeGraph.vue?vue&type=style&index=0&id=73af2531&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrSchemeGraph.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73af2531"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73af2531', __exports__)) {
    api.reload('73af2531', __exports__)
  }
  
  module.hot.accept("./AttrSchemeGraph.vue?vue&type=template&id=73af2531", () => {
    api.rerender('73af2531', render)
  })

}


export default __exports__